'use strict';

// Mobile apps controller
angular.module('mobile-apps').controller('TranslationOrderView', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'AvailableLanguages',
	'GlossaryMain',
	'FileUploader',
	'EntryMain',
	'Utilities',
	'ConfigData',
	'TranslationImport',
	'Authentication',
	'TranslationOrder',
	'TranslationOrderConstants',
	'$state',
	'$modal',
	'$q',
	'DEFAULT_TAG_CATEGORIES',
	'TagMain',
	function (
		$rootScope,
		$scope,
		$stateParams,
		AvailableLanguages,
		GlossaryMain,
		FileUploader,
		EntryMain,
		Utilities,
		ConfigData,
		TranslationImport,
		Authentication,
		TranslationOrder,
		TranslationOrderConstants,
		$state,
		$modal,
		$q,
        DEFAULT_TAG_CATEGORIES,
        TagMain
	) {
		$scope.authentication = Authentication;
		$scope.orderId = $stateParams.orderId;
		$scope.TranslationOrderConstants = TranslationOrderConstants;

        $scope.tags = [];
        $scope.wordCountByTags = {};
        $scope.tagSearch = { tagName: '', tagCategory: 'NONE' };
        $scope.tagCategories = Object.values(DEFAULT_TAG_CATEGORIES);
        $scope.tagCategoryMenu = 'Category';

		$scope.data = {
			orderBase: 'app',
			initFailed: false,
			languageSearch: '',
			loadingInProgress: true,
			availableLanguagesToAdd: {},
			submitInProgress: false,
			processingImport: false,
			glossaryExists: false,
			languageServiceCostOrder: [],
			languageServiceCost: {},
			minLanguageCost: 0,
			stringSelectWordCount: {},
			selectStringOptionsOrder: [
				'untranslated',
				'withoutTarget',
				'sourceChanged',
				'invalidTarget',
				'all',
                'needsTranslation',
                'needsReview',
                'rejected',
                'needsTranslationOrRejected'
			],
			order: {},
			viewOnly: true,
			adminSettableStatus: [
				'requested',
				'processing',
				'done'
			],
			quoteEditableStatus: [
				'requested',
				'created',
				'declined',
				'accepted'
			],
			quoteApprovalStatus: [
				'created',
				'declined',
				'accepted'
			],
			submitableStatus: [
				'accepted',
				'processing',
				'done'
			],
			newStatus: 'draft',
			newQuoteDescription: '',
			newTotalCost: 0,
			newQuoteCurrency: '€',
			currencyList: [
				'€',
				'$',
				'£'
			],
			quoteStatus: 'Processing',
			contactEmail: ($rootScope.whitelabel && $rootScope.whitelabel.email && $rootScope.whitelabel.email.order) || ConfigData.applanga.email.contactUs,
			dueDate: null,
			configurationComplete: false,
			pendingRetrieve: undefined,
			languageCheckboxes: []
		};

		$scope.datePickersOpen = {
			dueDate: false
		};
		$scope.datePickerMinDate = new Date();


        /**
         * get selected keys from tags
         *
         * @return {Array}
         */
        $scope.getSelectedTagKeys = function() {
            var tagKeys = [];
            $scope.tags.forEach(function (tag) {
                if(tag.selected) {
                    tag.languageEntryIds.forEach(function (key) {
                        if(tagKeys.indexOf(key) === -1) {
                            tagKeys.push(key);
                        }
                    });
                }
            });

            return tagKeys;
        };

        /**
         * ng-change function for select tags checkbox
         */
        $scope.tagCheckboxChanged = function(checked) {
            $scope.isTagChecked = checked;
            $scope.changeOrder('stringOption', $scope.data.order.stringOption);
        };

        /**
         * find tags filtered with name and category
         */
        $scope.searchTags = function() {
            TagMain.loadTags($scope.mobileApp._id, false, function(err, result) {
                if (err) {
                    return Utilities.showMessage('Error!', 'Problem Loading Tags', 'error');
                }

                $scope.tags.length = 0;
                TagMain.tagIdsArray.forEach(function(tagId) {
                    $scope.tags.push(TagMain.tags[tagId]);
                });

                // exclude tags with no entry keys
                $scope.tags = $scope.tags.filter(tag => {
                    return tag.languageEntryIds.length;
                });

                if($scope.tagSearch.tagCategory !== 'NONE') {
                    $scope.tags = $scope.tags.filter(function (tag) {
                        return tag.category.toLowerCase() === $scope.tagSearch.tagCategory.toLowerCase();
                    });
                }

                if($scope.tagSearch.tagName !== '') {
                    $scope.tags = $scope.tags.filter(function (tag) {
                        return tag.name.includes($scope.tagSearch.tagName);
                    });
                }
            });
        };


        /**
         *
         * @param tagCategory
         */
        $scope.switchTagCategory = function(tagCategory) {
            $scope.tagSearch.tagCategory = tagCategory.name;
            $scope.tagCategoryMenu = tagCategory.name;
            $scope.searchTags();
        };

        $scope.selectTag = function(tag) {
            tag.selected = true;
            $scope.changeOrder('stringOption', $scope.data.order.stringOption);
        };

        $scope.excludeTag = function(tag) {
            tag.selected = false;
            $scope.changeOrder('stringOption', $scope.data.order.stringOption);
        };

		/**
		 * Updates a setting on the order
		 */
		$scope.changeOrder = function(setting, value, force) {
			if ($scope.data.viewOnly === true && force !== true) {
				// If the order only allowed to be viewed and force is not
				// set ignore
				return;
			}

			var languageIso;
			if (setting === 'serviceType') {
				$scope.data.order.serviceType = value;

				// Update price for all the languages
				for (languageIso in $scope.data.order.targetLanguages) {
					$scope.data.order.targetLanguages[languageIso].price = $scope.getServiceCostLanguage(value, languageIso);
				}
			} else if (setting === 'stringOption') {
				$scope.data.order.stringOption = value;

				// Update word count for all the languages
                for (languageIso in $scope.data.order.targetLanguages) {
                    $scope.data.order.targetLanguages[languageIso].words = $scope.getLanguageWords(languageIso);
                }
			}
		};


		/**
		 * Returns if all the data which is needed to submit the page is there
		 * @returns {boolean}
		 */
		$scope.dataComplete = function() {
			if ($scope.data.initFailed === true) {
				return false;
			}

			if (!$scope.data.order.targetLanguages) {
				return false;
			}
			return Object.keys($scope.data.order.targetLanguages).length !== 0;
		};

		/**
		 * Returns if all the data which is needed to submit the page is there
		 * @returns {boolean}
		 */
		$scope.quoteComplete = function() {
			if ($scope.data.initFailed === true) {
				return false;
			}
			if ($scope.data.newTotalCost <= 0) {
				return false;
			}
			if (!$scope.data.newQuoteDescription) {
				return false;
			}
			return true;
		};


		/**
		 * Returns a list of languages which match the current filter
		 */
		$scope.getFilteredLanguages = function() {
			var returnData = {};

			var searchString = $scope.data.languageSearch.toLowerCase();
			var languages = [];
			if($scope.data.order.status === 'draft'){
				languages = $scope.data.stringSelectWordCount;
			} else {
				languages = $scope.data.availableLanguagesToAdd;
			}

			for (var languageIso in languages) {
				if ($scope.data.viewOnly === true && $scope.isLanguageOnOrder(languageIso) === false) {
					// When the order got already saved only display the ordered languages
					continue;
				}
				if ($scope.data.availableLanguagesToAdd[languageIso] && ($scope.data.availableLanguagesToAdd[languageIso].toLowerCase().indexOf(searchString) !== -1 || languageIso.indexOf(searchString) !== -1)) {
					returnData[languageIso] = $scope.data.availableLanguagesToAdd[languageIso];
				}
			}

			return returnData;
		};


		/**
		 * Submit the order
		 */
		$scope.submit = function() {
			var sendData = {};
			sendData.mobileAppId = $scope.data.order.mobileApp._id;
			sendData.orderId = $scope.orderId;
			sendData.serviceType = $scope.data.order.serviceType;
			sendData.brief = $scope.data.order.brief;
			sendData.languages = Object.keys($scope.data.order.targetLanguages);
			sendData.dueDate = $scope.data.dueDate;
            sendData.tagKeys = [];

			if($scope.isTagChecked) {
                sendData.tagKeys = $scope.getSelectedTagKeys();
            }

			if ($scope.data.orderBase === 'app') {
				sendData.stringOption = $scope.data.order.stringOption;
			}

			$scope.data.submitInProgress = true;
			TranslationOrder.translationOrderRequest(sendData,
				function(response) {
					$scope.data.submitInProgress = false;

					// Redirect user after order create to the order overview page
					$state.go('listOrders');
				},
				function(err) {
					$scope.data.submitInProgress = false;
					Utilities.showMessageErrorResponse(err);
				}
			);

		};


		$scope.updateQuoteStatus = function() {
			$scope.data.quoteStatus = 'Processing';

			if ($scope.data.order.status === 'declined') {
				$scope.data.quoteStatus = 'Declined';
			}
			else if ($scope.data.order.status === 'created') {
				$scope.data.quoteStatus = 'Approval pending';
			}
			else if ($scope.data.order.status === 'accepted' || 
				$scope.data.order.status === 'done' || 
				$scope.data.order.status === 'processing') {
				$scope.data.quoteStatus = 'Accepted';
			}

			$scope.data.submissionCreated = $scope.data.order.submissions && $scope.data.order.submissions.length > 0;
			if ($scope.data.submissionCreated) {
				$scope.data.pendingRetrieve = $scope.data.order.submissions.filter(function(sub) { return !sub.delivered; }).length;
			}
		};

		$scope.updatePDConfigStatus = function() {
			if ($scope.data.order.mobileApp.pdEnabled === null) {
				$scope.data.configurationComplete = false;	
			}
			else if (!$scope.data.order.mobileApp.pdEnabled) {
				$scope.data.configurationComplete = true;	
			}
			else {
				$scope.data.configurationComplete = 
					$scope.data.order.mobileApp.pdEnabled && 
					$scope.data.order.mobileApp.pdInstanceName &&
					$scope.data.order.mobileApp.pdInstanceName !== '';
			}
		};

		/**
		 * Submit the quote
		 */
		$scope.submitQuote = function() {
			$scope.data.submitInProgress = true;
			TranslationOrder.updateOrder({
					orderId: $stateParams.orderId, 
					status: 'created',
					quoteDescription: $scope.data.newQuoteDescription, 
					totalCost: $scope.data.newTotalCost,
					quoteCurrency: $scope.data.newQuoteCurrency
				},
				function(response) {
					$scope.data.order.quoteDescription = response.quoteDescription;
					$scope.data.order.totalCost = response.totalCost;
					$scope.data.order.status = response.status;
					$scope.data.order.quoteCurrency = response.quoteCurrency;
					$scope.updateQuoteStatus();
					$scope.data.newQuoteDescription = '';
					$scope.data.newTotalCost = 0;
					$scope.data.submitInProgress = false;
					$scope.data.newQuoteCurrency = response.quoteCurrency;
				},
				function(err) {
					$scope.data.submitInProgress = false;
					Utilities.showMessageErrorResponse(err);
				}
			);
		};

		/**
		 * Decline the quote
		 */
		$scope.declineQuote = function() {
			var modalInstance = $modal.open({
				templateUrl: 'modules/orders/views/decline-quote-modal.client.view.html',
				controller: 'DeclineQuoteController',
				size: 'md'
			});

			modalInstance.result.then(function (options) {
				if (options.decline) {
					$scope.data.submitInProgress = true;
					TranslationOrder.updateOrder({
						orderId: $stateParams.orderId, 
						status: 'declined',
						declineReason: options.reason
					},
					function(response) {
						$scope.data.submitInProgress = false;
						$scope.data.order.status = response.status;
						$scope.updateQuoteStatus();
					},
					function(err) {
						$scope.data.submitInProgress = false;
						Utilities.showMessageErrorResponse(err);
					});
				}
			});
		};

		/**
		 * Accept the quote
		 */
		$scope.acceptQuote = function() {
			$scope.data.submitInProgress = true;
			TranslationOrder.sendOrder({ orderId: $stateParams.orderId },
				function(response) {
					$scope.data.submitInProgress = false;
					$scope.data.order.status = response.order.status;
					$scope.updateQuoteStatus();
				},
				function(err) {
					$scope.data.submitInProgress = false;
					Utilities.showMessageErrorResponse(err);
				}
			);
		};

		/**
		 * Submits
		 */
		$scope.submitOrder = function() {
			if ($scope.data.order.mobileApp.pdInstanceName !== 'external') {
				if (!$scope.data.order.paJobNumber || $scope.data.order.paJobNumber === '') {
					Utilities.showMessage(
						'Error!',
						'The PA Job Number field is required for internal PD submissions',
						'error'
					);
					return;
				}
			}

			$scope.data.submitInProgress = true;
			var sendData = {};
			sendData.paJobNumber = $scope.data.order.paJobNumber;
			sendData.pdDepartment = $scope.data.order.pdDepartment;
			sendData.pdSubmissionName = $scope.data.order.pdSubmissionName;
			sendData.dueDate = $scope.data.dueDate;
			sendData.orderId = $stateParams.orderId;

			TranslationOrder.translationOrderSubmission(sendData,
				function(response) {
					$scope.data.submitInProgress = false;
					$scope.data.order.status = response.order.status;
					$scope.updateQuoteStatus();

					if (response.message) {
						$scope.data.PDError = response.message;
						Utilities.showMessage(
							'Warning!',
							'Something went wrong while submitting to Project Director: ' + response.message.toString(),
							'warning'
						);
					}
					else {
						Utilities.showMessage(
							'Success',
							'A new submission was created in Project Director',
							'success'
						);
					}

					$state.reload();
				},
				function(err) {
					$scope.data.submitInProgress = false;
					Utilities.showMessageErrorResponse(err);
				}
			);
		};

		/**
		 * Submits
		 */
		$scope.saveProductionInfo = function() {
			$scope.data.submitInProgress = true;
			var sendData = {};
			sendData.paJobNumber = $scope.data.order.paJobNumber;
			sendData.pdDepartment = $scope.data.order.pdDepartment;
			sendData.pdSubmissionName = $scope.data.order.pdSubmissionName;
			sendData.dueDate = $scope.data.dueDate;
			sendData.orderId = $stateParams.orderId;

			TranslationOrder.saveProductionInfo(sendData,
				function(response) {
					$scope.data.submitInProgress = false;
				},
				function(err) {
					$scope.data.submitInProgress = false;
					Utilities.showMessageErrorResponse(err);
				}
			);
		};


		/**
		 * Returns how much the service costs per word in a given language
		 */
		$scope.getServiceCostLanguage = function(service, languageIso) {

			if (!$scope.data.languageServiceCost.hasOwnProperty(service)) {
				return undefined;
			}

			if ($scope.data.languageServiceCost[service].hasOwnProperty('languages') && $scope.data.languageServiceCost[service].languages.hasOwnProperty(languageIso)) {
				return $scope.data.languageServiceCost[service].languages[languageIso].cost;
			}

			return $scope.data.languageServiceCost[service].defaultCost;
		};


		/**
		 * Returns the per word cost for the given language
		 */
		$scope.getLanguageWordCost = function(languageIso) {
			if ($scope.data.order.status !== 'draft') {
				// Price is fixed from the time the order did get send so
				// simply return
				return $scope.data.order.targetLanguages[languageIso].price;
			}

			// Price has to get calculated
			return $scope.getServiceCostLanguage($scope.data.order.serviceType, languageIso);
		};


		/**
		 * Returns the numbers of words which have to be translated for the
		 * language
		 */
		$scope.getLanguageWords = function(languageIso) {
            const stringOption = $scope.data.order.stringOption;
            const selectedTags = $scope.tags ? $scope.tags.filter(tag => tag.selected) : [];
            let sourceWordCount = -1;
            let targetWordCount = -1;

		    if($scope.isTagChecked && selectedTags.length) {
                $scope.data.order.sourceWords.forEach(function (sourceKey) {
                    selectedTags.forEach(tag => {
                        if(tag.languageEntryIds.includes(sourceKey)) {
                            sourceWordCount = Math.max(sourceWordCount, $scope.wordCountByTags[tag.name][languageIso]);
                        }
                    });
                });

                $scope.data.stringSelectWords[languageIso][stringOption].forEach(function (targetKey) {
                    selectedTags.forEach(tag => {
                        if(tag.languageEntryIds.includes(targetKey)) {
                            targetWordCount = Math.max(targetWordCount, $scope.wordCountByTags[tag.name][languageIso]);
                        }
                    });
                });

            }

			if ($scope.data.orderBase === 'file') {
				// If the order is based of a file it always takes the
				// count of the source language
				return $scope.data.order.sourceWordCount;
			}

            if ($scope.data.stringSelectWordCount.hasOwnProperty(languageIso)) {
                // Language exists so there is a count
                if(selectedTags.length && targetWordCount <= $scope.data.stringSelectWordCount[languageIso][stringOption]) {
                    if(targetWordCount === -1) return 0;
                    return targetWordCount;
                }
                return $scope.data.stringSelectWordCount[languageIso][stringOption];
            } else {
                // Language does not exist yet so take source count
                if(selectedTags.length && sourceWordCount <= $scope.data.stringSelectWordCount[languageIso][stringOption]) {
                    if(sourceWordCount === -1) return 0;
                    return sourceWordCount;
                }
                return $scope.data.order.sourceWordCount;
            }
		};


		/**
		 * Returns the total cost for the given language
		 */
		$scope.getLanguageWordCount = function(languageIso) {

			// returning language word count
			return $scope.data.order.targetLanguages[languageIso].words;
		};


		/**
		 * Returns total order cost
		 */
		$scope.getFullWordCount = function() {

			// Word count has to get calculated
			var wordCount = 0;
			for (var languageIso in $scope.data.order.targetLanguages) {
				wordCount += $scope.getLanguageWordCount(languageIso);
			}

			return wordCount;
		};


		/**
		 * Returns if the language is on the order list
		 */
		$scope.isLanguageOnOrder = function(languageIso) {
			if (!$scope.data.order.targetLanguages) {
				return false;
			}
			return $scope.data.order.targetLanguages.hasOwnProperty(languageIso);
		};
		
		$scope.toggleLanguageToOrder = function(languageIso){
			if($scope.data.languageCheckboxes[languageIso]){
				$scope.removeLanguageFromOrder(languageIso);
			} else {
				$scope.addLanguageToOrder(languageIso);			
			}
		};

		/**
		 * Adds a language to the order
		 */
		$scope.addLanguageToOrder = function(languageIso) {
			if ($scope.data.viewOnly === true) {
				return;
			}

			$scope.data.order.targetLanguages[languageIso] = {
				price: $scope.getLanguageWordCost(languageIso),
				words: $scope.getLanguageWords(languageIso)
			};
			$scope.data.languageCheckboxes[languageIso] = true;
		};


		/**
		 * Removes a language from the order
		 */
		$scope.removeLanguageFromOrder = function(languageIso) {
			if ($scope.data.viewOnly === true) {
				return;
			}

			delete $scope.data.order.targetLanguages[languageIso];
			$scope.data.languageCheckboxes[languageIso] = false;
		};


		/**
		 * Returns how many languages are on the order
		 */
		$scope.numLanguageOnOrder = function() {
			if (!$scope.data.order.targetLanguages) {
				return 0;
			}
			return Object.keys($scope.data.order.targetLanguages).length;
		};


		/**
		 * Updates the status on an order
		 */
		$scope.adminSetStatus = function() {
			TranslationOrder.updateOrder({orderId: $stateParams.orderId, status: $scope.data.newStatus},
				function(response) {
					$scope.data.order.status = response.status;
					$scope.updateQuoteStatus();
				},
				function(err) {
					Utilities.showMessageErrorResponse(err);
				}
			);
		};


		/**
		 * Retrieves the submission from PD and imports the new translations
		 */
		$scope.adminRetrieveFromPD = function(force) {
			$scope.data.submitInProgress = true;
			var retrieveSubmissionPromises = {};
			$scope.data.order.submissions.forEach(function (submission) {

				if (force || !submission.delivered) {
					// Find the language id
					var importLanguage = Object.keys($scope.data.order.targetLanguages).find(function(lang) { return lang === submission.targetLanguage; });
					if (!importLanguage) {
						// The language doesn't exist in the Order, skip
						return;
					}
					var languageIds = Object.keys(EntryMain.languages);
					var language;
					for (var i=0;i<languageIds.length;i++) {
						var checkLanguage = EntryMain.languages[languageIds[i]];
						if (checkLanguage.name === importLanguage) {
							language = checkLanguage;
							break;
						}
					}

					var sendData = {
						submissionId: submission._id,
						languageId: language._id,
						orderId: $stateParams.orderId,
						mobileAppId: $scope.mobileApp._id,
						groupId: EntryMain.defaultGroup._id,
						data: JSON.stringify ({
							options: {
								onlyAsDraft: true,
								setStatus: 2,
								addToOrder: $scope.data.order._id,
								markAsDelivered: submission._id
							}
						})
					};

					retrieveSubmissionPromises[submission._id] = TranslationOrder.importSubmission(sendData,
						function(response) {
							if (response.file) {
								var existingFile = $scope.data.order.files.find(function(file) { return file._id === response.file._id; });
		
								if (!existingFile) {
									$scope.data.order.files.push(response.file);
								}
							}
						}).$promise;
				}
			});

			$q.all(retrieveSubmissionPromises)
				.then(function(promisesData) {
					if ($scope.data.order.status === 'done') {
						$scope.data.submitInProgress = false;
						Utilities.showMessage(
							'Success',
							'The delivery file has been imported correctly',
							'success'
						);
					}
					else {
						TranslationOrder.updateOrder({orderId: $stateParams.orderId, status: 'done'},
							function(response) {
								$scope.data.submitInProgress = false;
								$scope.data.order.status = response.status;
								$scope.updateQuoteStatus();
								Utilities.showMessage(
									'Success',
									'The delivery file has been imported correctly',
									'success'
								);

								TranslationOrder.sendStatusTranslationOrderEmail({ orderId: $stateParams.orderId });
                                $state.reload();
							},
							function(err) {
								Utilities.showMessageErrorResponse(err);
							}
						);
					}
				})
				.catch(function(promisesErr) {
					$scope.data.submitInProgress = false;
					if (promisesErr && promisesErr.data && promisesErr.data.message) {
						$scope.data.PDError = promisesErr.data.message.toString();
					}
					Utilities.showMessageErrorResponse(promisesErr);
                    $state.reload();
				});
		};


		/**
		 * check if the order delete is allowed
		 * @return {boolean}
		 */
		$scope.cancelOrderAllowed = function() {
			if($scope.data.submitInProgress) {
				return false;
			}
			if(['draft', 'requested', 'created', 'declined'].includes($scope.data.order.status) && $scope.data.order.mobileApp.permissions.can_delete_orders) {
				return true;
			}
			if(['draft', 'requested', 'accepted', 'processing'].includes($scope.data.order.status) && ($scope.data.order._isAdmin || $scope.data.order._isTPT)) {
				return true;
			}
			return false;
		};


		/**
		 * Deletes the current order.
		 * Is only possible if it has status "draft" or the user is a "superAdmin" and at least the quoteStatus is "accepted"
		 */
		$scope.cancelOrder = function() {
			TranslationOrder.cancelOrder({orderId: $stateParams.orderId},
				function(response) {
                    $scope.data.order.status = 'canceled';

					// Redirect user after order got deleted to the order overview page
					$state.go('listOrders');
				},
				function(err) {
					Utilities.showMessageErrorResponse(err);
				}
			);
		};

		/**
		 * Returns all the files of the given type (source/delivery)
		 */
		$scope.getFilesOfType = function(type) {
			var returnData = [];

			if ($scope.data.order.files) {
				$scope.data.order.files.forEach(function(file) {
					if (file.description.type === type) {
						returnData.push(file);
					}
				});
			}

			return returnData;
		};


		/**
		 * Downloads the glossary
		 */
		$scope.downloadGlossary = function() {
			GlossaryMain.export($scope.mobileApp._id);
		};


		/**
		 * Uploads the given file as delivery for the order and imports its data
		 */
		$scope.uploadDeliveryFile = function (files, importLanguage) {
			// $scope.$$phase is checking if $digest is already in progress, so that it doesnt give the error "$rootScope:inprog: $digest already in progress"
			if (!files || files.length === 0 || $scope.$$phase) { 
				return;
			}

			// Find the language id
			var language;
			var languageIds = Object.keys(EntryMain.languages);
			for (var i=0;i<languageIds.length;i++) {
				var checkLanguage = EntryMain.languages[languageIds[i]];
				if (checkLanguage.name === importLanguage) {
					language = checkLanguage;
					break;
				}
			}

			if (!language) {
				Utilities.showMessage(
					'Error!',
					'The language "' + importLanguage + '" is not in app and can so not be imported.',
					'error'
				);
				return;
			}

			var entryKeys = [];

			$scope.data.processingImport = true;
			var importer = new TranslationImport($scope.mobileApp, EntryMain.defaultGroup, language);
			var options = {
			    importAll: false,
                onlyAsDraft: true,
                skipLockedTranslations: true,
                changeStatus: { selectedState: 2 },
				addToOrder: $scope.orderId
			};

			var file = files[0];
			var fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);

			if (['xliff', 'xlf'].indexOf(fileExtension) === -1) {
				var message = 'Currently only xliff files are supported as delivery.';
				return Utilities.showMessage('Wrong file type!!', message, 'error');
			}

			importer.importFileWithOptions(file, entryKeys, options).then(
				function(result) {
					$scope.data.processingImport = false;

					// Add the file we just uploaded
					if (result.file) {
						$scope.data.order.files.push(result.file);
					}
				}
			).catch(function(error) {
				$scope.data.processingImport = false;

				Utilities.showMessage(
					'Error!',
					error,
					'error'
				);
			});
		};


		/**
		 * Opens modal for PD configuration
		 */
		$scope.adminConfigurePD = function() {
			var modalInstance = $modal.open({
				templateUrl: 'modules/mobile-apps/views/connect-pd-modal.client.view.html',
				controller: 'PdConfigurationModalController',
				backdrop: true,
				size: 'md',
				resolve: {
					ModalData: function() {
						return {
							mobileApp: $scope.mobileApp
						};
					}
				}
			}).result.then(function (result) {
				EntryMain.loadMobileApp($scope.mobileApp._id, true, function (err, result) {
					if (err) {
						Utilities.showMessageErrorResponse(err);
						return;
					}
					$scope.mobileApp = result;
					$scope.data.order.mobileApp = result;
					$scope.updatePDConfigStatus();
				});
			}, function(error) {
				if (!(error === 'cancel' || error === 'escape key press' || error === undefined)) {
					throw error;
				}
			});
		};


        /**
         * Opens modal for PD Language Map
         */
        $scope.pdMapLanguages = function() {
            if($scope.data.submissionCreated) {
                return Utilities.showMessage('Error!', 'Order is submitted: cannot configure Language Mapping' , 'error');
            }

            var modalInstance = $modal.open({
                templateUrl: 'modules/mobile-apps/views/pd-language-map-modal.client.view.html',
                controller: 'PdLanguageMapModalController',
                backdrop: true,
                size: 'md',
                resolve: {
                    ModalData: function() {
                        return {
                            mobileApp: $scope.mobileApp,
                            order: $scope.data.order
                        };
                    }
                }
            });

            modalInstance.result.then(function () {
                EntryMain.loadMobileApp($scope.mobileApp._id, true, function (err, result) {
                    if (err) {
                        Utilities.showMessageErrorResponse(err);
                        return;
                    }
                    $scope.mobileApp = result;
                });
            }, function(error) {
                if (!(error === 'cancel' || error === 'escape key press' || error === undefined)) {
                    throw error;
                }
            });
        };


		/**
		 * Opens the datepicker with the given name
		 * @param datePickerName The datepicker to open
         */
		$scope.openDatePicker = function(datePickerName, event) {
			$scope.datePickersOpen[datePickerName] = true;
		};


        /**
         * count all words from all target languages
         *
         * @return {number}
         */
		$scope.totalWordCount = function () {
            var count = 0;

            Object.values($scope.data.order.targetLanguages).forEach(function(languageData) {
                count += languageData.words || 0;
            });

            return count;
        };


		/**
		 * Initializes everything
		 */
		function init() {
			// Load the order itself which all its data
			TranslationOrder.getOrder({orderId: $stateParams.orderId}).$promise.then(
				function(orderData) {

					if (orderData.files && orderData.files.length !== 0) {
						$scope.data.orderBase = 'file';
					} else {
						$scope.data.orderBase = 'app';
					}

					$scope.data.order = orderData;
					$scope.data.newStatus = orderData.status;
					$scope.data.dueDate = orderData.dueDate ? new Date(orderData.dueDate) : null;
					if (orderData.quoteCurrency) {
						$scope.data.newQuoteCurrency = orderData.quoteCurrency;
					}
					$scope.updateQuoteStatus();
					$scope.updatePDConfigStatus();

					return orderData;
				}
			).then(
				function(response) {

					var promises = {};

					// Get directly the data like languages and groups which
					// is needed for file-delivery upload
					promises.loadMobileApp = EntryMain.loadMobileApp(response.mobileApp._id, false);

					// Get all the translation settings like languages which can be ordered,
					// which services are available and minimum price
					promises.translationSettings = TranslationOrder.getTranslationSettings({mobileAppId: response.mobileApp._id}).$promise;

					if ($scope.data.orderBase === 'app') {
						promises.translationOrderWordCount = TranslationOrder.translationOrderWordCount({mobileAppId: response.mobileApp._id}).$promise;
						promises.translationOrderWord = TranslationOrder.translationOrderWord({mobileAppId: response.mobileApp._id}).$promise;
					}


					var glossaryPromise = $q.when();
					if ($scope.data.order._isAdmin) {
						glossaryPromise = $q(function (resolve, reject) {
							GlossaryMain.loadGlossary(response.mobileApp._id, true, function (error, data) {
								if (error) {
									return reject(error);
								}
								resolve(data);
							});
						});
					}

					promises.glossary = glossaryPromise;

					return $q.all(promises).then(
						function(promisesData) {
							$scope.data.loadingInProgress = false;

							// The minimum amount to charge for each language that gets ordered
							$scope.data.minLanguageCost = promisesData.translationSettings.minLanguageCost;

							// Get all the languages which can be added to order
							$scope.data.availableLanguagesToAdd = promisesData.translationSettings.orderableLanguages;

							if (promisesData.glossary && Object.keys(promisesData.glossary).length) {
								$scope.data.glossaryExists = true;
							}

							var mobileApp = promisesData.loadMobileApp;
							var translationCostsArray = promisesData.translationSettings.translationServices;
							var appWordCounts = promisesData.translationOrderWordCount;
							var appWords = promisesData.translationOrderWord;

							$scope.mobileApp = mobileApp;
							$scope.data.languageServiceCost = {};
							$scope.data.languageServiceCostOrder = [];

							$scope.data.submissionCreated = $scope.data.order.submissions && $scope.data.order.submissions.length > 0;
							if ($scope.data.submissionCreated) {
								$scope.data.pendingRetrieve = $scope.data.order.submissions.filter(function(sub) { return !sub.delivered; }).length;
							}

							// Convert the array with the translation costs to an object
							translationCostsArray.forEach(function(translationCostEntry) {
								$scope.data.languageServiceCostOrder.push(translationCostEntry.id);
								$scope.data.languageServiceCost[translationCostEntry.id] = translationCostEntry;
							});

							if ($scope.data.order.status === 'draft') {
								// Order is still in draft mode so set default values
								$scope.data.order.serviceType = 'translate';
								$scope.changeOrder('stringOption', 'untranslated',true);

								// If in draft mode data can still be changed
								$scope.data.viewOnly = false;

								if (!$scope.data.order.targetLanguages) {
									$scope.data.order.targetLanguages = {};
								}

								if (appWordCounts !== undefined) {
									// If the order is based on an app it has specific]
									// word counts which have to be used
									$scope.data.order.sourceWordCount = appWordCounts.sourceLanguage;
									$scope.data.stringSelectWordCount = appWordCounts.targetLanguages;

									for (var languageIso in appWordCounts.targetLanguages) {
										if (languageIso !== $scope.data.order.sourceLanguage && $scope.data.availableLanguagesToAdd.hasOwnProperty(languageIso)) {
											$scope.addLanguageToOrder(languageIso);
											$scope.data.languageCheckboxes[languageIso] = true;
										}
									}
								}

                                if (appWords) {
                                    $scope.data.order.sourceWords = appWords.sourceLanguage;
                                    $scope.data.stringSelectWords = appWords.targetLanguages;
                                }

                                TagMain.loadTags($scope.mobileApp._id, true, function(err, result) {
                                    if (err) {
                                        return Utilities.showMessage('Error!', 'Problem Loading Tags', 'error');
                                    }

                                    TagMain.tagIdsArray.forEach(function(tagId) {
                                        const tag = TagMain.tags[tagId];
                                        if(tag.languageEntryIds.length) {
                                            $scope.tags.push(tag);
                                        }
                                    });

                                    TagMain.loadTagCategories($scope.mobileApp._id, true, function (err, tagCategories) {
                                        if(err) {
                                            $scope.data.initFailed = true;
                                            return Utilities.showMessageErrorResponse(err);
                                        }
                                        if (tagCategories && Object.keys(tagCategories).length) {
                                            Object.values(tagCategories).forEach(function (tagCategory) {
                                                if (!$scope.tagCategories.find(function (item) { return item.name === tagCategory.name; })) {
                                                    $scope.tagCategories.push(tagCategory);
                                                }
                                            });
                                        }

                                        $scope.tagCategories.unshift({ name: 'NONE' });
                                        $scope.wordCountPromises = {};

                                        // add colors to tags
                                        $scope.tags.forEach(function (tag) {
                                            var tagCategory = $scope.tagCategories.find(function (category) {
                                                return category.name === tag.category;
                                            });

                                            if(tagCategory) {
                                                tag.color = tagCategory.color;
                                            }

                                            $scope.wordCountPromises[tag.name] = TranslationOrder.countWords({ mobileAppId: $scope.data.order.mobileApp._id, entryKeys: tag.languageEntryIds }).$promise;
                                        });

                                        $q.all($scope.wordCountPromises).then(data => {
                                            for(const tagName in data) {
                                                $scope.wordCountByTags[tagName] = data[tagName].wordCount;
                                            }
                                        })
                                        .catch(err => {
                                            Utilities.showMessageErrorResponse(err);
                                        });
                                    });
                                });
							}
						}
					);

				}
			).catch(function(err) {
				Utilities.showMessageErrorResponse(err);

				$scope.data.initFailed = true;
				$scope.data.loadingInProgress = false;
			});
		}


		init();
	}
]);
